import { z } from 'zod'
import { ActorNameSchema, FileRefSchema } from '@/shared/lib'

export const INVOICE_STATUSES = ['issued', 'payment_claimed', 'paid'] as const
export const InvoiceStatusSchema = z.enum(INVOICE_STATUSES)
export type InvoiceStatus = z.infer<typeof InvoiceStatusSchema>

// Счёт: по проекту (project_id) ИЛИ прямой счёт компании (project_id === null,
// company_id всегда). Виден и заказчику (read-only + «Оплатил»). overdue derived.
// payment_claimed — заказчик отметил оплату, ждёт подтверждения сотрудника.
export const InvoiceSchema = z.object({
  id: z.string(),
  // Прямой счёт компании — project_id null; company_id есть всегда.
  project_id: z.string().nullable(),
  company_id: z.string(),
  number: z.string(),
  amount_kopecks: z.number(),
  due_date: z.string().optional(),
  file: FileRefSchema,
  status: InvoiceStatusSchema,
  overdue: z.boolean(),
  issued_by: ActorNameSchema,
  issued_at: z.string(),
  payment_claimed_at: z.string().nullish(),
  paid_at: z.string().optional(),
  // Теги — employee-only (заказчик счета видит, теги — нет).
  tags: z.array(z.string()).optional(),
})
export type Invoice = z.infer<typeof InvoiceSchema>
